<template>
  <base-floating-card @close="close">
    <div id="scs-profile-editor">
      <div id="contact-data-wrapper">
        <div class="top-section">
          <photo-input
            class="scs-input"
            :initial="contact.profilePicture"
            :processing="processing.photo"
            @scs-input="submitProfilePicture"
          />
          <div class="names">
            <editable-field
              class="scs-input"
              title="First Name:"
              inputType="text"
              :value="contact.given_name"
              @scs-input="givenNameInput"
              @scs-blur="submitGivenName"
            />
            <editable-field
              class="scs-input"
              title="Last Name:"
              inputType="text"
              :value="contact.family_name"
              @scs-input="familyNameInput"
              @scs-blur="submitFamilyName"
            />
          </div>
          <div class="contact-information">
            <editable-field
              class="scs-input"
              title="Phone Number:"
              inputType="text"
              :value="contact.phoneNumber"
              @scs-input="phoneNumberInput"
              @scs-blur="submitPhoneNumber"
            />
            <editable-field
              class="scs-input"
              title="Email Address:"
              inputType="text"
              :value="contact.email"
              @scs-input="emailInput"
              @scs-blur="submitEmail"
            />
          </div>
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "./UI/FloatingCards/BaseFloatingCard.vue";
import EditableField from "./UI/EditableField.vue";
import { formatDate, formatTime } from "../Helpers/invoice.js";
import PhotoInput from "./Elements/PhotoInput.vue";
export default {
  data() {
    return {
      given_name: undefined,
      family_name: undefined,
      phoneNumber: undefined,
      email: undefined,
      processing: {
        email: false,
        family_name: false,
        given_name: false,
        phoneNumber: false,
        photo: false,
      },
    };
  },

  methods: {
    formatDate,
    formatTime,
    givenNameInput(val) {
      this.given_name = val;
    },
    familyNameInput(val) {
      this.family_name = val;
    },
    phoneNumberInput(val) {
      this.phoneNumber = val;
    },
    emailInput(val) {
      this.email = val;
    },
    async submitGivenName() {
      if (this.given_name) {
        let editPayload = {
          variable: "given_name",
          value: this.given_name,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          contact: this.contact,
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitFamilyName() {
      if (this.family_name) {
        let editPayload = {
          variable: "family_name",
          value: this.family_name,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          contact: this.contact,
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitPhoneNumber() {
      if (this.phoneNumber) {
        let editPayload = {
          variable: "phoneNumber",
          value: this.phoneNumber,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          contact: this.contact,
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitEmail() {
      if (this.email) {
        let editPayload = {
          variable: "email",
          value: this.email,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          contact: this.contact,
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },
    async submitProfilePicture(picture) {
      let photo = await this.$store.dispatch("addPhoto", picture);
      if (photo) {
        let editPayload = {
          variable: "profilePicture",
          value: photo,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          contact: this.contact,
        };
        await this.$store.dispatch("editContact", editPayload);
      }
    },

    close() {
      this.$emit("close");
    },
  },
  components: {
    BaseFloatingCard,
    EditableField,
    PhotoInput,
  },
  emits: ["close"],
  props: ["contact"],
};
</script>
<style scoped>
@media screen {
  @media (max-width: 800px) {
    #scs-profile-editor {
      height: fit-content;
      max-height: 70vh;
      z-index: 12;
    }

    #contact-data-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .top-section {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;
    }
    .scs-input {
      margin: 10px 20px;
      height: auto;
      max-width: 150px;
    }
  }
  @media (min-width: 800px) {
    #scs-profile-editor {
      width: 500px;
    }

    #contact-data-wrapper {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .top-section {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }
    .scs-input {
      margin: 10px 20px;
      height: auto;
      max-width: 150px;
    }
  }
}
</style>
